/** Smart Search 2.0 admin export went live on this date (session list + export floor). */
export const SS2_EXPORT_MIN_DATE = '2026-07-16';

export function ss2ExportMinDate() {
  return new Date(`${SS2_EXPORT_MIN_DATE}T00:00:00`);
}

export function sanitizeExportFilenameSegment(value) {
  return (
    String(value || 'customer')
      .trim()
      .replace(/[^a-zA-Z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'customer'
  );
}

export function buildSs2ExportFilename(customerId, customers = []) {
  const customer = customers.find((candidate) => candidate.customerId == customerId);
  const name = sanitizeExportFilenameSegment(customer?.customerName);
  const today = new Date().toISOString().slice(0, 10);
  return `ss2-sessions-${name}-${today}.csv`;
}
